"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignBoundingBox = exports.updateMorphWeights = exports.removeData = void 0;
const viewer_shared_math_1 = require("@shapediver/viewer.shared.math");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const gl_matrix_1 = require("gl-matrix");
const THREE = __importStar(require("three"));
const SDObject_1 = require("../../objects/SDObject");
const ThreejsData_1 = require("../../types/ThreejsData");
const removeData = (renderingEngine, dataObject) => {
    if (dataObject.userData.removed === true)
        return;
    dataObject.userData.removed = true;
    switch (true) {
        case dataObject.userData.SDtype === SDObject_1.SD_DATA_TYPE.GEOMETRY:
            dataObject.traverse((o) => {
                if (dataObject.id !== o.id && o.userData.removed === true)
                    return;
                o.userData.removed = true;
                if (o instanceof THREE.Mesh ||
                    o instanceof THREE.Line ||
                    o instanceof THREE.Points ||
                    o instanceof THREE.LineSegments ||
                    o instanceof THREE.LineLoop) {
                    renderingEngine.scene.remove(o);
                    renderingEngine.pulseEffectManager.remove(o);
                    renderingEngine.geometryLoader.removeFromGeometryCache(o.geometry.userData.cacheKey);
                    renderingEngine.materialLoader.removeFromMaterialCache(o.material.userData.cacheKey);
                    const texturesToRemove = [];
                    for (const t in o.material) {
                        if (o.material[t] instanceof THREE.Texture) {
                            o.material[t].name = t;
                            if (t !== "envMap") {
                                if (!texturesToRemove.includes(o.material[t]))
                                    texturesToRemove.push(o.material[t]);
                            }
                        }
                    }
                    for (const texture of texturesToRemove) {
                        if (texture.userData.cacheKey &&
                            renderingEngine.materialLoader.threeJsTextureCache[texture.userData.cacheKey]) {
                            renderingEngine.materialLoader.threeJsTextureCache[texture.userData.cacheKey].usage--;
                        }
                        else {
                            if (texture.name === "sphericalNormalMap") {
                                renderingEngine.geometryLoader.removeFromGemSphericalMapsCache(o.geometry.userData.primitiveSDid +
                                    "_" +
                                    o.geometry.userData.primitiveSDversion);
                                texture.dispose();
                            }
                            else {
                                texture.dispose();
                            }
                        }
                    }
                }
            });
            break;
        case dataObject.userData.SDtype === SDObject_1.SD_DATA_TYPE.THREEJS:
            break;
        case dataObject.userData.SDtype === SDObject_1.SD_DATA_TYPE.MATERIAL:
            break;
        case dataObject.userData.SDtype === SDObject_1.SD_DATA_TYPE.LIGHT:
            dataObject.traverse((o) => {
                if (o instanceof THREE.Light)
                    o.dispose();
            });
            break;
        case dataObject.userData.SDtype === SDObject_1.SD_DATA_TYPE.HTML_ELEMENT_ANCHOR:
            renderingEngine.htmlElementAnchorLoader.removeData(dataObject.userData.SDid, dataObject.userData.SDversion);
            break;
        case dataObject.userData.SDtype === SDObject_1.SD_DATA_TYPE.ANIMATION:
            break;
        default:
            // if there is no valid conversion here, call the convertData of the implementation
            break;
    }
};
exports.removeData = removeData;
const updateMorphWeights = (node, obj) => {
    if (!node || !obj)
        return;
    for (let i = 0, len = node.data.length; i < len; i++) {
        if (node.data[i] instanceof viewer_shared_node_tree_1.GeometryData) {
            const data = node.data[i];
            const dataChild = (obj.children.find((oc) => oc.SDid === data.id &&
                oc.SDversion === data.version));
            if (dataChild)
                dataChild.traverse((o) => {
                    if (o instanceof THREE.Points ||
                        o instanceof THREE.LineSegments ||
                        o instanceof THREE.LineLoop ||
                        o instanceof THREE.Line ||
                        o instanceof THREE.Mesh)
                        o.morphTargetInfluences = data.morphWeights;
                });
        }
    }
    for (let i = 0, len = node.children.length; i < len; i++) {
        const nodeChild = node.children[i];
        if (!nodeChild)
            continue;
        const objChild = (obj.children.find((oc) => oc.SDid === nodeChild.id));
        if (objChild)
            (0, exports.updateMorphWeights)(nodeChild, objChild);
    }
};
exports.updateMorphWeights = updateMorphWeights;
const assignBoundingBox = (node, data, renderingEngineId, convertedObjectData) => {
    // assign the bb
    if (data instanceof viewer_shared_node_tree_1.GeometryData) {
        const geometry = data;
        let bb = new viewer_shared_math_1.Box();
        const clone = convertedObjectData.clone();
        clone.matrix.identity();
        clone.matrixWorld.identity();
        clone.position.set(0, 0, 0);
        clone.scale.set(1, 1, 1);
        clone.quaternion.set(0, 0, 0, 1);
        clone.applyMatrix4(new THREE.Matrix4().fromArray(node.worldMatrix));
        const threeBox = new THREE.Box3().setFromObject(clone, true);
        bb = new viewer_shared_math_1.Box(gl_matrix_1.vec3.fromValues(threeBox.min.x, threeBox.min.y, threeBox.min.z), gl_matrix_1.vec3.fromValues(threeBox.max.x, threeBox.max.y, threeBox.max.z));
        // adjust the general BB
        node.boundingBox.union(bb);
        // create the specific BB if it doesn't exist yet
        if (!node.boundingBoxViewport[renderingEngineId])
            node.boundingBoxViewport[renderingEngineId] = new viewer_shared_math_1.Box();
        // adjust the specific BB
        node.boundingBoxViewport[renderingEngineId].union(bb);
    }
    else if (data instanceof ThreejsData_1.ThreejsData) {
        const threejsData = data;
        const bbThree = new THREE.Box3().setFromObject(threejsData.obj);
        // adjust the general BB
        node.boundingBox.union(new viewer_shared_math_1.Box(gl_matrix_1.vec3.fromValues(...bbThree.min.toArray()), gl_matrix_1.vec3.fromValues(...bbThree.max.toArray())));
        // create the specific BB if it doesn't exist yet
        if (!node.boundingBoxViewport[renderingEngineId])
            node.boundingBoxViewport[renderingEngineId] = new viewer_shared_math_1.Box();
        // adjust the specific BB
        node.boundingBoxViewport[renderingEngineId].union(new viewer_shared_math_1.Box(gl_matrix_1.vec3.fromValues(...bbThree.min.toArray()), gl_matrix_1.vec3.fromValues(...bbThree.max.toArray())));
    }
};
exports.assignBoundingBox = assignBoundingBox;
//# sourceMappingURL=SceenTreeManagerUtils.js.map